
  import { validateInputImportMixin, multiselectImportMixin } from '../plugins/mpowerInputsInit';

  export default {
    inject: ['$validator'],
    name: 'MPowerValidateInput',
    mixins: [validateInputImportMixin, multiselectImportMixin],
  };
